// CUSTOMIZATION:
// - 25-42 Added Chip for categories

import React from 'react';
import { useSelector } from 'react-redux';
import {
  RichTextSection,
  richTextHasContent,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';
import { defineMessages, useIntl } from 'react-intl';
import { Chip, ChipLabel } from 'design-react-kit';

const UOMoreInfos = ({ content }) => {
  const intl = useIntl();
  const actions = useSelector((state) => state?.actions?.actions?.object);
  const userCanEdit = actions.some((el) => el.id === 'edit');
  return richTextHasContent(content.ulteriori_informazioni) ||
    (content.subjects.length > 0 && userCanEdit) ? (
    <RichTextSection
      data={content.ulteriori_informazioni}
      tag_id="more-info"
      title={intl.formatMessage(messages.other_info)}
      anchorOffset={true}
    >
      {content.subjects?.length > 0 && userCanEdit && (
        <div className="subjects">
          <p className="mt-4">{intl.formatMessage(messages.subjects)}</p>
          {content.subjects?.map((item, i) => (
            <Chip
              color="primary"
              disabled={false}
              large={false}
              simple
              tag="div"
              key={item + i}
              className="me-2"
            >
              <ChipLabel tag="span">{item}</ChipLabel>
            </Chip>
          ))}
        </div>
      )}
    </RichTextSection>
  ) : null;
};

export default UOMoreInfos;

const messages = defineMessages({
  other_info: {
    id: 'other_info',
    defaultMessage: 'Ulteriori informazioni',
  },
  subjects: {
    id: 'subjects',
    defaultMessage: 'Categorie',
  },
});
